"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("./style.css"));
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
var _get2 = _interopRequireDefault(require("lodash/get"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/*
 * Displays the count of the values that are not null or 0
 * Settings is passed with 'namePath' to find the items
 * to count in the array
 */
var _default = exports["default"] = function _default(settings) {
  return function (_ref) {
    var value = _ref.value,
      row = _ref.row;
    var noValue = false;
    if ((0, _isNil2["default"])(value) || value.length === 0) {
      noValue = true;
    }
    var count = 0;
    value.map(function (item) {
      var v = "".concat((0, _get2["default"])(item, settings.namePath));
      if (!(0, _isNil2["default"])(v) && v !== 'null' && v !== '0') {
        count++;
      }
      return count;
    });
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: row,
      className: _style["default"].container
    }, !noValue && count > 0 ? /*#__PURE__*/_react["default"].createElement("div", null, count) : /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-center"
    }));
  };
};